module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_3_1_4.01167133.png";